import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { IChangeDto } from 'src/types'

import { useStyles } from './styles'
import { StateChangeIcon } from 'src/assets/icons/v2/StateChangeIcon'
import { EmptyUserIcon } from 'src/assets/icons/v2/EmptyUserIcon'
import { truncateString } from 'src/common/utils'

interface IChangeFormModalProps {
  open: boolean
  handleClose: () => void
  formValues: Pick<IChangeDto, 'after' | 'before'> | null
}

const ChangeFormModal = ({ open, handleClose, formValues }: IChangeFormModalProps) => {
  const classes = useStyles()

  if (!formValues) {
    return null
  }

  const beforeKeys = formValues.before ? Object.keys(JSON.parse(formValues.before)) : null
  const afterKeys = formValues.after ? Object.keys(JSON.parse(formValues.after)) : null
  const before = formValues.before ? JSON.parse(formValues.before) : null
  const after = formValues.after ? JSON.parse(formValues.after) : null

  return (
    <ModalWrapper open={open} className={classes.modalWrapper} onClose={handleClose}>
      <div className={classes.tableHeader}>
        <StateChangeIcon size={80} />
        <Typography className={classes.title}>
          <HelperWrapper t="change-logs-header-title" />
        </Typography>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <HelperWrapper t="change-logs-field-column" />
              </TableCell>
              {before && (
                <TableCell align="center">
                  <HelperWrapper t="change-logs-before-column" />
                </TableCell>
              )}
              {after && (
                <TableCell align="center">
                  <HelperWrapper t="change-logs-after-column" />
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {(afterKeys ?? beforeKeys)?.map((key) => (
              <TableRow key={key} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {key}
                </TableCell>
                {before && (
                  <TableCell style={{ wordBreak: 'break-all' }}>
                    {transformValue(before?.[key])}
                  </TableCell>
                )}
                {after && (
                  <TableCell
                    style={{
                      wordBreak: 'break-all',
                      // , whiteSpace: 'pre-wrap'
                    }}
                  >
                    {transformValue(after?.[key])}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ModalWrapper>
  )
}

function transformValue(val: unknown) {
  if (!val) return <EmptyUserIcon size={24} />

  if (typeof val === 'string' && val.startsWith('http') && val.includes('trackgood.io')) {
    return (
      <div>
        <img src={val} alt="Generated Image" style={{ width: '380px', height: 'auto' }} />
        <Typography style={{ wordBreak: 'break-word' }}>
          <a href={val} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px' }}>
            {truncateString(val, 50)}
          </a>
        </Typography>
      </div>
    )
  }

  if (Array.isArray(val)) {
    return !val.length ? (
      <EmptyUserIcon size={24} />
    ) : typeof val[0] === 'string' ? (
      val.join(', ')
    ) : (
      JSON.stringify(val)
    )
  }

  switch (typeof val) {
    case 'string':
      return val
    default:
      return JSON.stringify(val)
  }
}

export { ChangeFormModal }
